export enum AgreementStatus {
  Default = '',
  Never = 'never_agreed',
  Agreed = 'agreed',
  ReAgreement = 'need_re_agreement'
}
